import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { PLAYER_WON_CHANNEL } from '@bg-shared/constants/socketChannels';
import { GameId } from '@bg-shared/enums/GameId';
import { IPlayerWonModel } from './interfaces';

class PlayerWonEvents {
    public subscribe(gameId: GameId, callback: ICallback<IPlayerWonModel>): () => void {
        return webSocketsRepository.on<IPlayerWonModel>(PLAYER_WON_CHANNEL, (data) => {
            if (data.gameId === gameId) {
                callback(data);
            }
        });
    }
}

export const playerWonEvents = new PlayerWonEvents();
